"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var BelowText_1 = __importDefault(require("../BelowText/BelowText"));
var InputLabel_1 = __importDefault(require("../InputLabel/InputLabel"));
var reserveSpace_1 = __importDefault(require("../../utils/reserveSpace"));
var TextArea_1 = __importDefault(require("semantic-ui-react/dist/commonjs/addons/TextArea"));
/**
 * A TextArea component can be used to allow for extended user input. It can also be dragged by the handle in the lower right to increase its size.
 */
var TextArea = /** @class */ (function (_super) {
    __extends(TextArea, _super);
    function TextArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChangeWrapper = function (event, data) {
            return _this.props.onChange && _this.props.onChange(data.value);
        };
        return _this;
    }
    TextArea.prototype.render = function () {
        var _a = this.props, className = _a.className, label = _a.label, indicator = _a.indicator, error = _a.error, helperText = _a.helperText, onChange = _a.onChange, fluid = _a.fluid, disabled = _a.disabled, placeholder = _a.placeholder, maxLength = _a.maxLength, value = _a.value, rows = _a.rows, reserveSpace = _a.reserveSpace, cleanedProps = __rest(_a, ["className", "label", "indicator", "error", "helperText", "onChange", "fluid", "disabled", "placeholder", "maxLength", "value", "rows", "reserveSpace"]);
        return (React.createElement("span", __assign({}, cleanedProps, { className: this.genTextAreaClass() }),
            label && React.createElement(InputLabel_1.default, { label: label, indicator: indicator }),
            React.createElement(TextArea_1.default, __assign({ value: value, onChange: this.onChangeWrapper }, rows && { rows: rows }, disabled && { disabled: disabled }, placeholder && { placeholder: placeholder }, maxLength && { maxLength: maxLength })),
            reserveSpace_1.default(this.props) && React.createElement(BelowText_1.default, { error: error, helperText: helperText })));
    };
    TextArea.prototype.genTextAreaClass = function () {
        var _a = this.props, className = _a.className, error = _a.error, fluid = _a.fluid;
        var classString = 'scuf-textarea-wrapper';
        if (className) {
            classString += " " + className;
        }
        if (error) {
            classString += ' error';
        }
        if (fluid) {
            classString += ' fluid';
        }
        return classString;
    };
    TextArea.defaultProps = {
        rows: 5,
    };
    return TextArea;
}(React.Component));
exports.default = TextArea;
